import { render, staticRenderFns } from "./BasicBar.vue?vue&type=template&id=66ad5520&scoped=true"
import script from "./BasicBar.vue?vue&type=script&lang=js"
export * from "./BasicBar.vue?vue&type=script&lang=js"
import style0 from "./BasicBar.vue?vue&type=style&index=0&id=66ad5520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ad5520",
  null
  
)

export default component.exports